import React from 'react';
// import { NavLink } from 'react-router-dom';

const teamMembers = [
    {
        // image: require('./../../images/our-team4/pic1.png'),
        membername: 'Ahmad Mustafa',
        position: 'President & Founder',
        ahmad:'Ahmad Mustafa is a civil engineer with 8 years of experience in the construction industry, bringing expertise and a strong foundation in project planning, estimation, and execution.'
    },
    {
        // image: require('./../../images/our-team4/pic2.png'),
        membername: 'Saad Irshad',
        position: 'CEO & Co-Founder',
        saad:'Saad Irshad is a marketing manager with 10 years of experience in business, specializing in strategic marketing, brand development, and driving growth through innovation.'
    },
    {
        // image: require('./../../images/our-team4/pic3.png'),
        membername: 'Asad Irshad',
        position: 'Co-Founder',
        asad:'Asad Irshad is a civil engineer with 8 years of experience in project planning, estimation, and execution in the construction industry.'

    }
]

class Team2 extends React.Component {
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-white inner-page-padding">
                    <div className="container">
                        {/* TITLE START */}
                        <div className="section-head">
                            <div className="mt-separator-outer separator-center">
                                <div className="mt-separator">
                                    <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Leadership</h2>
                                </div>
                            </div>
                        </div>
                        {/* TITLE END */}
                        {/* IMAGE Team START */}
                        <div className="section-content">
                            <div className="row">
                                {teamMembers.map((item, index) => (
                                    <div key={index} className="col-md-4 col-sm-6 col-xs-6 col-xs-100pc m-b30   ">
                                        <div className="our-team-1 hover-animation-1">
                                            <div className="profile-image scale-in-center"><img src={item.image} alt=""/></div>
                                            <div className="figcaption">
                                                <h4>{item.membername}</h4>
                                                <h5>{item.position}</h5>
                                                <p >{item.ahmad}</p>
                                                <p >{item.saad}</p>
                                                <p >{item.asad}</p>
                                                {/* <div className="icons">
                                                    <NavLink to={"#"} ><i className="fa fa-facebook" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-twitter" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-instagram" /></NavLink>
                                                    <NavLink to={"#"} ><i className="fa fa-rss" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-youtube" /></NavLink>
                                                    <NavLink to={"#"} > <i className="fa fa-linkedin" /></NavLink>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Team2;